"use strict";

define('rs/models/task',['rs/models/abstract', 'rs/helper'], function (AbstractModel, helper) {
  var Task = AbstractModel.extend({
    properties: ["assignmentDisplayName", "taskDisplayName", "templateType"],
    serverProperties: ["assignment", "documentId", "documentTitle", "personId", "processInstanceId", "studyId", "studyLabel", "studyTitle", "taskBeginDate", "taskHistoryId", "urgentDate", "taskType.activityDate", "taskType.assignments", "taskType.id", "taskType.passive", "taskType.requiredAssignments", "taskType.status", "taskType.taskAnswers", "taskType.taskName", "taskType.taskQuestion", "taskType.taskState", "taskType.updatedUserAuthId", "taskType.version", "templateType"],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setTaskDisplayName(helper.parseServerEnum(this.getTaskTypeTaskName()));
      this.setAssignmentDisplayName(helper.parseServerEnum(this.getAssignment()));
      this.setTaskTypeTaskState(helper.toProperCase(this.getTaskTypeTaskState()));
    },
    isPastDue: function isPastDue() {
      var today = new Date().getTime();
      return today > this.getUrgentDate();
    },
    getTaskTypeName: function getTaskTypeName() {
      return this.get('taskType.taskName');
    },
    requestSetValue: function requestSetValue(value) {
      return this.constructor.requestSetWorkflow(this, value);
    },
    getTaskTypeRequiredAssignments: function getTaskTypeRequiredAssignments() {
      return _.chain(String(this._super.apply(this, arguments) || '').trim().split(/,\s*/)).compact().reject(function (a) {
        return a == 'IRB_ORGANIZATION';
      }).value();
    }
  }, {
    rootURI: '/rs/api/workflow/',
    parsers: {
      '#GET#task/:id': function GETTask_Id(data) {
        return this.models(data);
      },
      '#GET#task': function GETTask(data) {
        return this.models(data);
      }
    },
    requestTasksByDocument: function requestTasksByDocument(id) {
      return this.get('task/' + id);
    },
    requestTasks: function requestTasks(params) {
      return this.get('task', params);
    },
    requestSetWorkflow: function requestSetWorkflow(workflow, value) {
      return this.post('task/' + value, workflow, {
        jsonBody: true
      });
    }
  });
  return Task;
});

